var _g, _rect, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMarkIconOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000000950"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000000948"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2521",
    width: 18,
    height: 18,
    rx: 9,
    fill: "#E9A100"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "help"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_322_2195",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_322_2195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "help_2",
    d: "M8.9625 13.5C9.225 13.5 9.44688 13.4094 9.62813 13.2281C9.80938 13.0469 9.9 12.825 9.9 12.5625C9.9 12.3 9.80938 12.0781 9.62813 11.8969C9.44688 11.7156 9.225 11.625 8.9625 11.625C8.7 11.625 8.47813 11.7156 8.29688 11.8969C8.11562 12.0781 8.025 12.3 8.025 12.5625C8.025 12.825 8.11562 13.0469 8.29688 13.2281C8.47813 13.4094 8.7 13.5 8.9625 13.5ZM8.2875 10.6125H9.675C9.675 10.2 9.72188 9.875 9.81563 9.6375C9.90938 9.4 10.175 9.075 10.6125 8.6625C10.9375 8.3375 11.1938 8.02812 11.3813 7.73438C11.5688 7.44063 11.6625 7.0875 11.6625 6.675C11.6625 5.975 11.4062 5.4375 10.8938 5.0625C10.3813 4.6875 9.775 4.5 9.075 4.5C8.3625 4.5 7.78437 4.6875 7.34062 5.0625C6.89687 5.4375 6.5875 5.8875 6.4125 6.4125L7.65 6.9C7.7125 6.675 7.85312 6.43125 8.07187 6.16875C8.29063 5.90625 8.625 5.775 9.075 5.775C9.475 5.775 9.775 5.88438 9.975 6.10313C10.175 6.32188 10.275 6.5625 10.275 6.825C10.275 7.075 10.2 7.30938 10.05 7.52813C9.9 7.74688 9.7125 7.95 9.4875 8.1375C8.9375 8.625 8.6 8.99375 8.475 9.24375C8.35 9.49375 8.2875 9.95 8.2875 10.6125Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIconOrange);
export default __webpack_public_path__ + "static/media/question-mark-icon-orange.446efcc5ccd9c51570f538d1a5211d13.svg";
export { ForwardRef as ReactComponent };